/**
 * @generated SignedSource<<5b81db25980df6bce4ad6fc4a6d39f4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentProvider_subscription$data = {
  readonly isActive: boolean | null | undefined;
  readonly redirectUrl: string | null | undefined;
  readonly " $fragmentType": "PaymentProvider_subscription";
};
export type PaymentProvider_subscription$key = {
  readonly " $data"?: PaymentProvider_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentProvider_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentProvider_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "3a79892f33bf1a136e7cab568d895831";

export default node;
